import { isFileNameEndsWith } from 'utils/baseName'
/**
 * Checks whether the file name of a file looks like an Applanix navrover file.
 * This is done by looking at the extension and checking whether it is ".T02".
 */
export function isNavApplanixFileName (fileName) {
  return isFileNameEndsWith(fileName, '.t04')
}
